<template>
  <div class="card">
    <div class="top">
      <div class="t_left">
        <span @click="$emit('changeShowCard', 0)" v-if="showCard!=-1">{{ lang.overviewOfProgress }}</span>
        <span @click="$emit('changeShowCard', 1)" v-if="showCard!=-1">{{lang.difficultProblems}}</span>
        <span @click="$emit('changeShowCard', 2)" v-if="showCard!=-1">{{ lang.abilityStratification }}</span>
        <span @click="$emit('changeShowCard', 3)" class="active">{{lang.teachingSuggestions}}</span>
      </div>
      <div class="t_right" v-if="false">
        <img src="../../../../assets/img/teachingMode/changeUp.png" :style="{cursor:showCard>0?'pointer':'not-allowed'}" @click="$emit('changeShowCard',0)">
        <img src="../../../../assets/img/teachingMode/changeDown.png" :style="{cursor:showCard<3?'pointer':'not-allowed'}" @click="$emit('changeShowCard',1)">
      </div>
    </div>
    <div class="main">
      <div class="m_item" v-for="(item, index) in cardData" :key="index" :style="exportBoolean?`box-shadow:none`:''">
        <div class="m_item_top">
          <span>{{ item.title }}</span>
        </div>
        <div class="m_item_content">
          <span>{{ item.content }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myMixin } from "@/common/mixin";
export default {
  mixins: [myMixin],
  props:{
    analysisData:{
      type:Array,
      default:()=>{
        return []
      }
    },
    showCard:{
      type:Number,
      default:0
    },
    exportBoolean:{
      type:Boolean,
      default:false
    }

  },
  data() {
    return {
      // cardData: [],
      statusList: [
				this.lang.unfinished,
				this.lang.completed,
				this.lang.pause,
				this.lang.stop,
			],
    };
  },
  computed: {
    cardData() {
      let _result = [];

      if (this.analysisData && this.analysisData.length > 0) {
        _result = JSON.parse(JSON.stringify(this.analysisData));
      }

      return _result;
    },
  },
  methods:{
    getLang(){
      let lang = 'cn'
      if(this.lang.lang == 'cn'){
        lang = 'Chinese.'
      }else if(this.lang.lang == 'hk'){
        lang = 'Traditional Chinese.'
      }else if(this.lang.lang == 'en'){
        lang = 'English.'
      }
      return lang
    },
    generated(list,num = 0){
      return new Promise((resolve)=>{
      let _msg = ``
      list.forEach((s) => {
				_msg += `学生：${s.name}\n总结：${s.summary}\n总节点数量：${
					s.stage
				}\n任务状态：${this.statusList[s.status]}\nID：${s.id}\n`;
				s.nodeData.forEach((n, nIndex) => {
					_msg += `【节点${(nIndex + 1).toString().padStart(2, "0")} ${
						n.messageList[0] ? n.messageList[0].aiName : "-"
					}】表情：${
						n.status == "0" ? "微笑" : n.status == "1" ? "不高兴" : "无表情"
					}\n`;
					n.messageList.forEach((m) => {
						_msg += `${m.userName}(${m.chatTime})：\n${m.userContent}\n${m.aiName}：\n${m.aiContent}\n`;
					});
				});
				_msg += "\n";
			});

      let _msg2 = `NOTICE
Role: 你是一个资深的教育教学专家，需要基于学生在AI学习助手中的学习表现分析，结合教学法理论，为教师提供具体可行的教学改进建议。。
Language: Please use the same language as the user requirement, if the user speaks Chinese, the specific text of your answer should also be in Chinese.
ATTENTION: Use '##' to SPLIT SECTIONS, not '#'. Output format carefully referenced "Format example".
Instruction: Based on the context, follow "Format example", write content

#Context
## 任务
你需要完成：
1. 针对发现的学习问题和困难，提供具体的教学策略建议
2. 基于不同学生群体的特点，提供差异化教学指导
3. 结合当前学习进度和效果，给出课程改进方向
4. 提供至少3条具体可操作的教学建议

# 输入信息

## 学习分析结果
${_msg}

## 教学背景信息
- 当前教学进度和阶段【进度总览】
- 学生疑难问题【疑难问题】


# 建议生成框架

## 1. 针对学习卡点的教学策略

**概念理解困难 → 概念澄清策略**
- 多元表征教学法（文字、图像、实例、类比）
- 概念图构建，帮助学生建立知识网络
- 错误概念诊断和纠正策略
- 分步骤概念建构，降低认知负荷

**逻辑推理困难 → 思维支架策略**
- 提供思维导图和推理框架
- 示范性思维过程展示
- 逐步撤除支架的引导策略
- 同伴互助和思维碰撞

**操作技能困难 → 技能训练策略**
- 分解复杂技能为子技能训练
- 提供操作示范和练习机会
- 及时反馈和纠错指导
- 从简单到复杂的梯度练习

**应用迁移困难 → 迁移促进策略**
- 多情境应用练习
- 相似性和差异性分析
- 策略性知识传授
- 真实情境问题解决

## 2. 针对能力分层的差异化教学

**优秀组学生 → 挑战性教学**
- 提供拓展性学习任务和挑战性问题
- 鼓励自主探究和创新思维
- 安排同伴指导和助教角色
- 提供高阶思维训练机会

**良好组学生 → 引导性教学**
- 加强概念理解和应用练习
- 提供适度挑战的学习任务
- 及时反馈和鼓励支持
- 逐步培养自主学习能力

**待提升组学生 → 支持性教学**
- 重点关注基础概念掌握
- 提供个性化辅导和额外支持
- 情感激励和信心建立
- 小步子教学和多次练习

## 3. 针对学习态度的激励策略

**学习动机不足 → 动机激发策略**
- 连接学习内容与学生兴趣和生活
- 设置合适的学习目标和成就感
- 采用多样化的教学活动
- 建立积极的师生互动关系

**情绪调节困难 → 情感支持策略**
- 创建安全、支持性的学习环境
- 教授情绪管理和压力应对技巧
- 及时识别和干预情绪问题
- 建立同伴支持网络

## 4. 针对教学过程的优化建议

**课堂教学优化**
- 调整教学节奏和难度梯度
- 增加互动环节和参与机会
- 优化教学方法和策略选择
- 加强形成性评估和及时反馈

**课后支持强化**
- 提供个性化作业和练习
- 建立学习小组和互助机制
- 加强家校沟通和协作
- 利用技术工具延伸学习

# 建议的质量标准

## 具体性
- **操作明确**：每个建议都要有具体的操作步骤
- **方法详细**：说明具体采用什么教学方法和技巧
- **资源清晰**：明确需要的教学资源和工具
- **时间可行**：考虑实际教学时间和条件限制

## 针对性
- **问题导向**：每个建议都要针对具体的学习问题或需求
- **数据支撑**：建议要基于实际的学习分析数据
- **个体差异**：考虑不同学生群体的特点和需求
- **情境适应**：结合实际的教学情境和条件

## 可行性
- **现实可操作**：建议要符合实际教学条件和资源
- **教师可执行**：考虑教师的专业能力和时间精力
- **学生可接受**：建议要符合学生的认知水平和接受能力

## 科学性
- **理论基础**：建议要有教育理论和研究支撑
- **循证决策**：基于数据分析结果做出科学判断


# 其他提示
1. **实用导向**：所有建议必须基于实际的分析数据，要具有实际操作价值，能够指导教师改进教学，避免泛泛而谈
2. **教育专业性**：运用教育学、心理学专业知识，提供科学的教学指导，并符合教育伦理
3. **个性化关注**：既要考虑整体情况，也要关注个别学生的特殊需求

请基于提供的学习分析结果，运用上述框架生成高质量的教学改进建议。

# Format example
[{"title":"{建议标题}","content":"{具体做法(详细的操作步骤和方法)与实施要点(关键注意事项和成功要素)}"},{"title":"{建议标题}","content":"{具体做法(详细的操作步骤和方法)与实施要点(关键注意事项和成功要素)}"}]
`

      let message = [{ role: "user", content: _msg2 }];
      this.chat_no_stream(message)
          .then((res) => {
            try {
              if (res) {
                let _group = JSON.parse(res);
                resolve(_group);
              } else {
                // 若response为空视为catch流程
                if (num < 4) {
                  this.generated(list, num + 1).then(resolve);
                } else {
                  resolve([]);
                }
              }
            } catch (error) {
              // 若解析失败则重试，最多5次（num从0 ~ 4）
              if (num < 4) {
                this.generated(list, num + 1).then(resolve);
              } else {
                resolve([]);
              }
            }
          })
          .catch(() => {
            // catch异常也重试，最多5次
            if (num < 4) {
              this.generated(list, num + 1).then(resolve);
            } else {
              resolve([]);
            }
          });
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  width: 100%;
  height: auto;
  border: 1px solid rgba(245, 248, 255, 0.25);
  box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
  box-shadow: 0px 16px 24px 2px rgba(0, 0, 0, 0.04);
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(16.700000762939453px);
  border-radius: 12px;
  box-sizing: border-box;
  gap: 20px;
  .top {
    width: 100%;
    height: 50px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    .t_left {
      white-space: nowrap;
      display: flex;
      gap: 20px;
      & > span {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: #797979;
        cursor: pointer;
      }
      &>.active{
        font-size: 18px;
        color: #000;
      }
    }
    .t_right{
      display: flex;
      gap: 20px;
      &>img{
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }
  }
  .main {
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 20px;
    background: #fafafa;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .m_item {
      width: 100%;
      height: auto;
      border: 1px solid rgba(245, 248, 255, 0.25);
      box-shadow: 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
      box-shadow: 0px 16px 24px 2px rgba(0, 0, 0, 0.04);
      box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
      backdrop-filter: blur(16.700000762939453px);
      border-top: solid 4px rgba(151, 71, 255, 1);
      border-radius: 12px;
      box-sizing: border-box;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 20px;
      .m_item_top {
        width: 100%;
        height: auto;
        & > span {
          color: rgba(0, 0, 0, 1);
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
        }
      }
      .m_item_content {
        width: 100%;
        height: auto;
        & > span {
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          letter-spacing: 0px;
          color: rgba(0, 0, 0, 1);
        }
      }
    }
  }
}
</style>
